import * as React from 'react';
import modules_73af8a26 from '../logo.module.css.mjs';

const XTwitterIcon = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M11.67 8.62 18.23 1h-1.55l-5.7 6.61L6.44 1H1.2l6.87 10-6.87 8h1.55l6.01-7 4.8 7h5.24zm-2.12 2.47-.7-1-5.54-7.92H5.7l4.47 6.4.7 1 5.8 8.3H14.3z",
        className: modules_73af8a26.darkInvert
    }));

export { XTwitterIcon };
//# sourceMappingURL=XTwitter.mjs.map
